import { notification } from "antd";
import "antd/dist/antd.css";
import "../common.scss";

export const toastNotification = (type = "success", message, description = "", placement = "topRight", duration = 5) => {
  message &&
    typeof message === "string" &&
    notification[type]({
      message: message,
      description: description,
      placement,
      duration: duration,
      className: "iiht-ant-notification",
    });
};
